/**
 * App-wide "a modal is open" signal.
 *
 * Every SkillSnap lightbox already calls `useFocusTrap` and/or `useEscapeClose`
 * while it is open, so those two hooks register here — that is the PRIMARY
 * signal and it needs no cooperation from (and no edit to) the modal components
 * themselves. `hotkeyRules.hasOpenModalElement` is the DOM backstop for the few
 * overlays that carry `role="dialog"` without using either hook (e.g. JobCard's
 * portaled "no longer accepting applications" notice).
 *
 * Deliberately a plain module counter, not React state: the only consumer is a
 * `keydown` handler that reads it synchronously at event time, so re-rendering
 * the tree on every modal open/close would be pure cost.
 */

let openCount = 0;

/** Call when a modal opens; call the returned function when it closes. */
export function registerOpenModal(): () => void {
  openCount += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    openCount = Math.max(0, openCount - 1);
  };
}

export function openModalCount(): number {
  return openCount;
}

/** Test-only escape hatch so one suite can't leak state into the next. */
export function resetModalRegistry(): void {
  openCount = 0;
}
